
export const cleanKPIResponse = (response: string) => {
  const sections = {
    executiveKPIs: [] as string[],
    coreFinancialKPIs: [] as string[],
    businessInitiatives: [] as string[],
    operatingKPIs: [] as string[]
  };

  // Split response into lines and clean them
  const lines = response.split('\n').map(line => line.trim()).filter(line => line.length > 0);
  
  let currentSection = '';
  
  for (const line of lines) {
    // Strip markdown bold markers for header matching
    const cleanLine = line.replace(/\*\*/g, '');
    
    // Check for section headers - flexible matching for various formats
    if (cleanLine.match(/1[\.\)]\s*Executive KPIs?/i) || cleanLine.match(/Executive KPIs?\s*[:]/i)) {
      currentSection = 'executiveKPIs';
      continue;
    } else if (cleanLine.match(/2[\.\)]\s*Core Financial KPIs?/i) || cleanLine.match(/Core Financial KPIs?\s*[:]/i)) {
      currentSection = 'coreFinancialKPIs';
      continue;
    } else if (cleanLine.match(/3[\.\)]\s*Business Initiatives?/i) || cleanLine.match(/Business Initiatives?\s*[:]/i)) {
      currentSection = 'businessInitiatives';
      continue;
    } else if (cleanLine.match(/4[\.\)]\s*Operating KPIs?/i) || cleanLine.match(/Operating KPIs?\s*[:]/i)) {
      currentSection = 'operatingKPIs';
      continue;
    }
    
    // Process bullet points - handle multiple formats:
    // "- item", "* item", "• item", "  - item", "1. item", "a) item"
    if (currentSection) {
      let bulletContent = '';
      
      if (line.match(/^[-*•]\s+/)) {
        // Standard bullets: - item, * item, • item
        bulletContent = line.replace(/^[-*•]\s+/, '').trim();
      } else if (line.match(/^\d+[\.\)]\s+/)) {
        // Numbered bullets: 1. item, 1) item
        // But skip if it looks like a section header (contains "KPI" or "Initiative")
        if (!cleanLine.match(/KPIs?|Initiatives?/i)) {
          bulletContent = line.replace(/^\d+[\.\)]\s+/, '').trim();
        }
      } else if (line.match(/^[a-z][\.\)]\s+/i)) {
        // Letter bullets: a. item, a) item
        bulletContent = line.replace(/^[a-z][\.\)]\s+/i, '').trim();
      } else if (line.match(/^\s+[-*•]\s+/)) {
        // Indented bullets
        bulletContent = line.replace(/^\s+[-*•]\s+/, '').trim();
      }
      
      if (bulletContent) {
        sections[currentSection as keyof typeof sections].push(bulletContent);
      }
    }
  }

  // Ensure exactly 5 items per section
  Object.keys(sections).forEach(key => {
    const sectionKey = key as keyof typeof sections;
    const items = sections[sectionKey];
    
    if (items.length < 5) {
      // Pad with placeholder items if less than 5
      const padding = Array(5 - items.length).fill('Data not available from current analysis');
      sections[sectionKey] = [...items, ...padding];
    } else if (items.length > 5) {
      // Take only first 5 if more than 5
      sections[sectionKey] = items.slice(0, 5);
    }
  });

  return sections;
};
